module.exports = __webpack_public_path__ + "img/3.cac1390b.jpg";